import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getHighRiskTransactions = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/monitoring/high_risk_transactions`
  return apiGet({ url, token, params })
}

export default function useMonitoringHighRiskTransactions({
  params,
  options = {}
}) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const mergedParams = { ...params, municipality_id }
  const queryFn = () => getHighRiskTransactions(token, mergedParams)
  const queryKey = ['monitoring-high-risk-transactions', mergedParams]

  return useQuery(queryKey, queryFn, {
    // A workflow is scoped server-side, so it stands in for a section_id.
    enabled: Boolean(params.section_id || params.workflow),
    ...options
  })
}
